import { ColoursObj } from '@eventr/common-storybook'
import { useEffect, useState } from 'react'
import { useScrollContext } from '../../../state/scrollState/scrollContext'

export function CarouselContainer({ children }: { children: React.ReactNode }) {
    const [atTop, setAtTop] = useState(useScrollContext.getState().atTop)
    // Connect to the store on mount, disconnect on unmount, catch state-changes in a reference
    useEffect(
        () => useScrollContext.subscribe((state) => setAtTop(state.atTop)),
        [setAtTop]
    )
    return (
        <div
            // className="carousel-container"
            style={{
                position: 'sticky',
                top: '0',
                zIndex: 100,
                backgroundColor: ColoursObj.backgrounds.header,
                borderBottom: atTop
                    ? ''
                    : `solid 2px ${ColoursObj.core.secondary}`,
            }}
        >
            {children}
        </div>
    )
}
